module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.tagType, _vm._b({
    tag: "div",
    staticClass: "Button",
    class: _vm.buttonClasses
  }, 'div', _vm.buttonAttributes, false), [(_vm.icon) ? _c('div', {
    staticClass: "Button-icon"
  }, [_c('icon', {
    attrs: {
      "name": _vm.icon
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.label) ? _c('div', {
    staticClass: "Button-label"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.meta) ? _c('div', {
    staticClass: "Button-meta"
  }, [_vm._v("\n    " + _vm._s(_vm.meta) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-328a0a08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonComponent.vue
// module id = 753
// module chunks = 1474